import { CreateItemGqlError } from '../../../../types';
import {
  InvoiceCustomFieldID,
  InvoiceCustomFieldUUID,
  UpdateInvoiceCustomFieldCacheKeys
} from '../../invoiceCustomFieldsTypes';

import { CACHE_UPDATE_INVOICE_CUSTOM_FIELD_QUERY } from '../../queries/cacheUpdateInvoiceCustomField.query';

import { useCacheUpdateQuery } from '../../../common/reactQuery/hooks/useCacheUpdateQuery';

interface CacheUpdateInvoiceCustomFieldOptions {
  cacheKeys?: UpdateInvoiceCustomFieldCacheKeys;
}

export interface CacheUpdateInvoiceCustomFieldInput {
  uuid: InvoiceCustomFieldID | InvoiceCustomFieldUUID;
  body?: string;
  invoiceUuid?: string;
  label?: string;
  location?: string;
  options?: Record<string, any>;
  order?: number;
}

export interface CacheUpdateInvoiceCustomFieldRecord {
  body?: string;
  createdAt: string;
  id: string;
  invoiceId: string;
  label: string;
  location: string;
  type: string;
  updatedAt: string;
  userId: string;
  uuid: string;
}

export interface CacheUpdateInvoiceCustomFieldResponse {
  updateInvoiceCustomField: {
    status: string;
    record: CacheUpdateInvoiceCustomFieldRecord;
    errors?: CreateItemGqlError;
    recordId: string;
    recordNanoId?: string;
    recordUuid?: string;
  };
}

export interface CacheUpdateInvoiceCustomFieldError {
  fullMessages: string[];
}

const action = 'updateInvoiceCustomField';

function useCacheUpdateInvoiceCustomField<
  RecordType = CacheUpdateInvoiceCustomFieldRecord
>({ cacheKeys }: CacheUpdateInvoiceCustomFieldOptions = {}) {
  const {
    updateCacheQuery,
    updateCacheQueryData,
    updateCacheQueryError,
    updateCacheQueryErrorMessage,
    updateCacheQueryLoading,
    updateCacheQueryReset
  } = useCacheUpdateQuery<
    CacheUpdateInvoiceCustomFieldInput,
    CacheUpdateInvoiceCustomFieldResponse,
    CacheUpdateInvoiceCustomFieldError,
    RecordType
  >({
    action,
    query: CACHE_UPDATE_INVOICE_CUSTOM_FIELD_QUERY,
    cacheKeys
  });

  return {
    updateInvoiceCustomField: updateCacheQuery,
    updateInvoiceCustomFieldData: updateCacheQueryData,
    updateInvoiceCustomFieldError: updateCacheQueryError,
    updateInvoiceCustomFieldErrorMessage: updateCacheQueryErrorMessage,
    updateInvoiceCustomFieldLoading: updateCacheQueryLoading,
    updateInvoiceCustomFieldReset: updateCacheQueryReset
  };
}

export default useCacheUpdateInvoiceCustomField;
